import PageableDuck from './PageableDuck';

const stripePayouts = new PageableDuck('stripePayouts');

export default stripePayouts.reducer;

export { stripePayouts };
